<main class="public-order">
    <section class="public-order-card" *ngIf="carregando()">
        <app-loading-indicator></app-loading-indicator>
        <div>
            <h1>Carregando pedido</h1>
            <p>Estamos buscando as informacoes da conferencia.</p>
        </div>
    </section>

    <section class="public-order-card error" *ngIf="!carregando() && erro">
        <div class="state-icon">!</div>
        <div>
            <h1>Pedido indisponivel</h1>
            <p>{{ erro }}</p>
        </div>
    </section>

    <ng-container *ngIf="!carregando() && !erro && pedido">
        <header class="public-header">
            <img src="assets/logo_global.png" alt="Global Parts">
            <div>
                <span>Conferencia de entrega</span>
                <h1>Pedido {{ numeroVenda() }}</h1>
            </div>
        </header>

        <section class="summary-card">
            <div>
                <span>Cliente</span>
                <strong>{{ valor(pedido, 'NOMEPARC') }}</strong>
            </div>
            <div>
                <span>CPF/CNPJ</span>
                <strong>{{ valor(pedido, 'CNPJ') }}</strong>
            </div>
            <div>
                <span>Emissao</span>
                <strong>{{ valor(pedido, 'DTNEG') || valor(pedido, 'DTATUAL') }}</strong>
            </div>
            <div>
                <span>Status</span>
                <strong>{{ valor(pedido, 'STATUS') || valor(pedido, 'STATUSNOTA') || 'ESTOQUE' }}</strong>
            </div>
        </section>

        <section class="delivery-card">
            <h2>Entrega</h2>
            <div>
                <span>Cliente de entrega</span>
                <strong>{{ valor(pedido, 'PARCEIROENTREGA') || valor(pedido, 'NOMEENTREGA') || valor(pedido, 'NOMEPARC') }}</strong>
            </div>
            <div>
                <span>Endereco de entrega</span>
                <strong>{{ enderecoEntregaLinha() }}</strong>
            </div>
            <div>
                <span>Cidade</span>
                <strong>{{ cidadeEntrega() }}</strong>
            </div>
            <div>
                <span>Fone</span>
                <strong>{{ valor(pedido, 'FONEENTREGA') || valor(pedido, 'TELPARC') || '-' }}</strong>
            </div>
        </section>

        <section class="products-card">
            <div class="products-title">
                <h2>Produtos</h2>
                <span>{{ itens.length }} item(ns)</span>
            </div>

            <article class="product-item" *ngFor="let item of itens; let i = index">
                <div class="product-topline">
                    <span>#{{ i + 1 }}</span>
                    <strong>{{ itemQtd(item) }}</strong>
                </div>
                <h3>{{ itemPartNumber(item) }}</h3>
                <p>{{ itemDescricao(item) }}</p>
                <div class="product-meta">
                    <span>CD: <strong>{{ itemCondicao(item) }}</strong></span>
                    <span>Fabricante: <strong>{{ itemFabricante(item) }}</strong></span>
                </div>
                <div class="product-serial" *ngIf="itemSerial(item)">
                    Serial: {{ itemSerial(item) }}
                </div>
            </article>
        </section>
    </ng-container>
</main>
